import { createLucideIcon } from "lucide-react"

// export const Var = createLucideIcon("var", [
//   ["path", { key: "p", d: "M7 18C9 18 15 6 17 6M7 7C10 1 14 23 17 17" }],
// ])

export const Var = createLucideIcon("var", [
  [
    "path",
    {
      key: "p",
      d: "M12.25 17.5C13.75 17.5 18.25 8.5 19.75 8.5M12.25 9.25C14.5 4.75 17.5 21.25 19.75 16.75M4 20C10 24 4-2 10 2M5 8C6 8 8 8 9 8",
    },
  ],
])
